import { render, staticRenderFns } from "./event-subscription-change-log.vue?vue&type=template&id=4497663e&"
import script from "./event-subscription-change-log.vue?vue&type=script&lang=ts&"
export * from "./event-subscription-change-log.vue?vue&type=script&lang=ts&"
import style0 from "./event-subscription-change-log.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports